(() => {
// Serialize keyed changes across cart surfaces. Never resolve a stale line by variant:
// the same variant can belong to several different customer accounts.
const cartChangeQueue = window.CartChangeQueue = {
  pending: Promise.resolve(),
  run(task) {
    const result = this.pending.then(task);
    this.pending = result.catch(() => {});
    return result;
  }
};


  const showLineError = (line, message) => {
    document.querySelectorAll('.cart-item__error').forEach(element => element.classList.add('hidden'));
    const lineError = document.getElementById(`Line-item-error-${line}`);
    if (lineError) {
      lineError.classList.remove('hidden');
      lineError.querySelector('.cart-item__error-text').textContent = message;
      return;
    }

    const cartError = document.getElementById('cart-errors');
    if (cartError) cartError.textContent = message;
  };

  const announceUpdate = () => {
    const liveRegion = document.getElementById('cart-live-region-text');
    if (!liveRegion) return;
    liveRegion.textContent = window.cartStrings.successfully_line_item_updated;
    liveRegion.setAttribute('aria-hidden', 'false');
    setTimeout(() => liveRegion.setAttribute('aria-hidden', 'true'), 1000);
  };

  const installCartItemsExtension = () => {
    const cartItemsClass = customElements.get('cart-items');
    if (!cartItemsClass || cartItemsClass.prototype.updateProperties) return;

    cartItemsClass.prototype.onChange = function (event) {
      if (event.target.name !== 'updates[]') return;
      this.updateQuantity(event.target.dataset.index, event.target.value,
        document.activeElement?.getAttribute('name'), event.target);
    };

    cartItemsClass.prototype.changeLine = async function (key, changes) {
    return cartChangeQueue.run(async () => {
      const sections = Array.from(new Set(this.getSectionsToRender()
        .filter(item => document.getElementById(item.id)).map(item => item.section)))
        .filter(Boolean).slice(0, 5);
      const refresh = async () => {
        const request = await fetch(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' });
        if (!request.ok) throw new Error(window.cartStrings.error);
        const cart = await request.json();
        const rendered = await fetch(`${window.routes.cart_url}?sections=${sections.join(',')}`, { cache: 'no-store' });
        if (!rendered.ok) throw new Error(window.cartStrings.error);
        cart.sections = await rendered.json();
        this.renderContentsAndDependencies(cart);
        return cart;
      };
      const request = await fetch(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' });
      if (!request.ok) throw new Error(window.cartStrings.error);
      const cart = await request.json();
      const item = key && cart.items.find(item => item.key === key);
      if (!item) {
        const current = await refresh();
        if (key && changes.quantity === 0) return current;
        throw new Error(window.cartStrings.error);
      }
      const body = JSON.stringify({ ...changes, id: key,
        quantity: changes.quantity ?? item.quantity, sections, sections_url: window.location.pathname });
      const changed = await fetch(routes.cart_change_url, { ...fetchConfig(), body });
      const response = await changed.json();
      if (!changed.ok || response.errors || response.status) {
        // A second tab can invalidate the key after the read. Refresh, never retry
        // using an index that might now point at a different account.
        if (changed.status === 400) await refresh();
        const error = new Error(changed.status === 400 ? window.cartStrings.error
          : (typeof response.errors === 'string' ? response.errors : response.description || window.cartStrings.error));
        error.customerMessage = error.message;
        throw error;
      }
      this.renderContentsAndDependencies(response);
      return response;
    });
  };

    cartItemsClass.prototype.updateQuantity = function (line, quantity, name, source) {
    const row = source?.closest('[data-cart-line-key]') || this.querySelector(`#CartItem-${Number(line)}`);
    const key = row?.dataset.cartLineKey;
    quantity && this.enableLoading(line);

    return this.changeLine(key, { quantity: Number(quantity) })
      .then(() => {
        const lineItem = document.getElementById(`CartItem-${line}`);

        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();

        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();
      })
      .catch((e) => {
        console.error(e);
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));

        const cartErrorElement = document.getElementById('cart-errors');
        cartErrorElement && (cartErrorElement.textContent = e.customerMessage || window.cartStrings.error);
        this.disableLoading();
      });
  };

    cartItemsClass.prototype.updateProperties = async function (key, properties, line) {
      this.enableLoading(line);

      try {
        const response = await this.changeLine(key, { properties });
        announceUpdate();
        return response;
      } catch (error) {
        console.error(error);
        const customerMessage = error.customerMessage || window.cartStrings.error;
        showLineError(line, customerMessage);
        const customerError = new Error(customerMessage);
        customerError.customerMessage = customerMessage;
        throw customerError;
      } finally {
        this.querySelectorAll('.loading-overlay').forEach(overlay => overlay.classList.add('hidden'));
        this.disableLoading();
      }
    };
  };

  if (customElements.get('cart-items')) {
    installCartItemsExtension();
  } else {
    customElements.whenDefined('cart-items').then(installCartItemsExtension);
  }

  if (customElements.get('cart-line-properties')) return;

  customElements.define('cart-line-properties', class CartLineProperties extends HTMLElement {
    constructor() {
      super();
      this.summary = this.querySelector('[data-cart-line-properties-summary]');
      this.editor = this.querySelector('[data-cart-line-properties-editor]');
      this.editButton = this.querySelector('[data-cart-line-properties-edit]');
      this.saveButton = this.querySelector('[data-cart-line-properties-save]');
      this.cancelButton = this.querySelector('[data-cart-line-properties-cancel]');
      this.errorElement = this.querySelector('[data-product-option-error]');
      this.contentWrap = this.closest('.cart-table-prd-content-wrap');
      this.fields = Array.from(this.querySelectorAll('[data-product-option-field]'));
      this.initialFieldState = this.fields.map(field => ({
        field,
        value: field.value,
        checked: field.checked,
        selected: field.tagName === 'SELECT'
          ? Array.from(field.options).map(option => option.selected)
          : null
      }));
      this.originalProperties = this.parseOriginalProperties();

      this.editButton?.addEventListener('click', () => this.open());
      this.cancelButton?.addEventListener('click', () => this.close(true));
      this.saveButton?.addEventListener('click', () => this.save());
    }

    parseOriginalProperties() {
      try {
        const properties = JSON.parse(this.dataset.properties || '{}');
        if (Array.isArray(properties)) {
          const hasValidEntries = properties.every(property => (
            Array.isArray(property)
            && property.length === 2
            && typeof property[0] === 'string'
          ));

          return hasValidEntries ? Object.fromEntries(properties) : null;
        }

        return properties && typeof properties === 'object' ? properties : null;
      } catch (error) {
        console.error('Unable to parse cart line properties.', error);
        return null;
      }
    }

    open() {
      if (!this.editor) return;
      this.summary.hidden = true;
      this.editor.hidden = false;
      this.contentWrap?.classList.add('is-editing-properties');
      this.editButton.setAttribute('aria-expanded', 'true');
      const firstField = Array.from(this.editor.querySelectorAll('input, select, textarea, button'))
        .map(field => field.themeSelectInstance?.trigger || field)
        .find(field => !field.disabled && field.type !== 'hidden' && field.getClientRects().length);
      firstField?.focus({ preventScroll: true });
    }

    close(returnFocus = false) {
      this.restoreInitialValues();
      this.querySelector('eight-bp-account-input')?.resetDraft?.();
      this.clearError();
      this.editor.hidden = true;
      this.summary.hidden = false;
      this.contentWrap?.classList.remove('is-editing-properties');
      this.editButton.setAttribute('aria-expanded', 'false');
      if (returnFocus) this.editButton.focus();
    }

    restoreInitialValues() {
      this.initialFieldState.forEach(({ field, value, checked, selected }) => {
        field.value = value;
        if ('checked' in field) field.checked = checked;
        if (selected) {
          Array.from(field.options).forEach((option, index) => {
            option.selected = selected[index];
          });
        }
        field.removeAttribute('aria-invalid');
        field.themeSelectInstance?.sync?.();
      });
    }

    buildProperties() {
      const properties = { ...this.originalProperties };
      delete properties._8bp_account_use_ref;
      this.fields.filter(field => !field.disabled).forEach(field => {
        const name = field.getAttribute('data-product-option-name');
        if (name) properties[name] = field.value;
      });
      return properties;
    }

    clearError() {
      this.showError('');
    }

    showError(message) {
      const box = this.errorElement?.querySelector('.product-form__error-message-wrapper');
      if (!box) return;
      box.querySelector('.product-form__error-message').textContent = message || '';
      box.hidden = !message;
    }

    setLoading(loading) {
      this.toggleAttribute('aria-busy', loading);
      this.saveButton.disabled = loading;
      this.cancelButton.disabled = loading;
      this.saveButton.querySelector('.loading-overlay__spinner')?.classList.toggle('hidden', !loading);
    }

    async save() {
      if (this.hasAttribute('aria-busy')) return;
      this.clearError();

      if (!this.originalProperties) {
        this.showError(window.cartStrings.error);
        return;
      }

      this.setLoading(true);
      try {
        await window.ProductOptions?.prepare?.(this);
      } catch (error) {
        this.showError(error.message || window.cartStrings.error);
        this.setLoading(false);
        return;
      }
      this.fields = Array.from(this.querySelectorAll('[data-product-option-field]'));
      if (!window.ProductOptions?.validateAndReport(this)) {
        this.setLoading(false);
        return;
      }

      const cartItems = this.closest('cart-items');
      if (!cartItems?.updateProperties) {
        this.showError(window.cartStrings.error);
        this.setLoading(false);
        return;
      }

      try {
        await cartItems.updateProperties(
          this.dataset.lineKey,
          this.buildProperties(),
          this.dataset.lineIndex
        );
      } catch (error) {
        if (this.isConnected) this.showError(error.message || window.cartStrings.error);
      } finally {
        if (this.isConnected) this.setLoading(false);
      }
    }
  });
})();
